import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

export default namespaceActions(NAME)([
  'TOGGLE_BENEFIT_UPLOADER',
  'CLOSE_BENEFIT_UPLOADER',
])
